import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";


/// Dashboard
import Home from "./components/Dashboard/Home";

import Performance from "./components/Dashboard/Performance";
import Projects from "./components/Dashboard/Projects";
import TaskSummary from "./components/Dashboard/TaskSummary";
import Blog from "./components/Dashboard/Blog";
import ManageClient from "./components/Dashboard/ManageClient";
import Report from "./components/Dashboard/Report";
import Finance from "./components/Dashboard/Finance";
import Employees from "./components/Dashboard/Employees";
import Task from "./components/Dashboard/Task";

import KilometerList from "./components/Kilometer/kilometerList";
import KilometerUpdate from './components/Kilometer/KilometerUpdate';
import ContactList from "./components/Contact/ContactList";
import SaleContactList from "./components/SaleContact/SaleContactList";
import BookingList from "./components/UsersListing/UsersList";
import UploadTutorialList from "./components/UploadTutorial/UploadTutorialList";
import EditTravel from "./components/UploadTutorial/EditTravel";
import BookingCalenderList from "./components/BookingCalender/BookingCalenderList";
import PaymentDetailList from "./components/PaymentDetail/PaymentDetailList";
import TripReviewList from "./components/TripReview/TripReviewList";

import Newsletters from "./components/Newsletters/NewslettersList";
import NewslettersUpdate from "./components/Newsletters/NewslettersUpdate";
/// Services
import AccountingList from "./components/AccountingSystem/AccountingList";
// import AddServices from "./components/Services/AddServices";
import EditAccounting from "./components/AccountingSystem/EditAccount";

import Services from "./components/Services/Services";
import AddServices from "./components/Services/AddServices";
import EditServices from "./components/Services/EditServices";

/// Packages
import Packages from "./components/Packages/Packages";
import AddPackages from "./components/Packages/AddPackages";
import EditPackages from "./components/Packages/EditPackages";

/// Location
import Location from "./components/Location/Location";
import AddLocation from "./components/Location/AddLocation";
import EditLocation from "./components/Location/EditLocation";

//Brands
import Brand from "./components/Brand/Brand";
import AddBrand from "./components/Brand/AddBrand";
import EditBrand from "./components/Brand/EditBrand";

//Brands
import Kitchen from "./components/Kitchen/Kitchen";
import AddKitchen from "./components/Kitchen/AddKitchen";
import EditKitchen from "./components/Kitchen/EditKitchen";

//Driving
import Driving from "./components/Driving/Driving";
import AddDriving from "./components/Driving/AddDriving";
import EditDriving from "./components/Driving/EditDriving";

//Bathroom management

import BathroomManagement from "./components/BathroomManagement/BathroomManagement";
import AddBathroomManagement from "./components//BathroomManagement/AddBathroomManagement";
import EditBathroomManagement from "./components/BathroomManagement/EditBathroomManagement";
//Living and sleeping
import Living from "./components/Living&Sleeping/Living";
import AddLiving from "./components/Living&Sleeping/AddLiving";
import EditLiving from "./components/Living&Sleeping/EditLiving";
//Outdoor
import Outdoor from "./components/Outdoor/Outdoor";
import AddOutdoor from "./components/Outdoor/AddOutdoor";
import EditOutdoor from "./components/Outdoor/EditOutdoor";

//Outdoor
import Feature from "./components/Feature/Feature";
import AddFeature from "./components/Feature/AddFeature";
import EditFeature from "./components/Feature/EditFeature";

//deals
import Deal from "./components/Deals/Deal";
import AddDeal from "./components/Deals/AddDeal";
import EditDeal from "./components/Deals/EditDeal";
/// Accessories
import Accessories from "./components/Accessories/Accessories";
import AddAccessories from "./components/Accessories/AddAccessories";
import EditAccessories from "./components/Accessories/EditAccessories";

/// Fuel
import Fuel from "./components/Fuel/Fuel";
import AddFuel from "./components/Fuel/AddFuel";
import EditFuel from "./components/Fuel/EditFuel";

///Campers
import Camper from "./components/Campers/Camper";
import AddCamper from "./components/Campers/AddCamper";
import EditCamper from "./components/Campers/EditCamper";

///Campers Sale
import SaleCamper from "./components/SaleCamper/SaleCamper";
import AddSaleCamper from "./components/SaleCamper/AddSaleCamper";
// import EditCamper from "./components/Campers/EditCamper";

///Campers Video
import CamperVideo from "./components/CamperVideo/CamperVideo";
import AddCamperVideo from "./components/CamperVideo/AddCamperVideo";
import EditCamperVideo from "./components/CamperVideo/EditCamperVideo";

///Campers
import Discount from "./components/Discount/Discount";
import AddDiscount from "./components/Discount/AddDiscount";
import EditDiscount from "./components/Discount/EditDiscount";

import AdminBlog from "./components/Blog/Blog";
import AddBlog from "./components/Blog/AddBlog";
import EditBlog from "./components/Blog/EditBlog";

//Vocher
import AdminVoucher from "./components/Voucher/Voucher";
import AddVoucher from "./components/Voucher/AddVoucher";
import EditVoucher from "./components/Voucher/EditVoucher";

//Vocher
import AdminCancellationPolicy from "./components/CancellationPolicy/CancellationPolicy";
import AddCancellationPolicy from "./components/CancellationPolicy/AddCancellationPolicy";
import EditCancellationPolicy from "./components/CancellationPolicy/EditCancellationPolicy";

//Ad-ons Equipments
import AdOns from "./components/AdOns/AdOns";
import AddAdOns from "./components/AdOns/AddAdOns";
import EditAdOns from "./components/AdOns/EditAdOns";

//Apps
import Contacts from './components/AppsMenu/Contacts';
import User from './components/AppsMenu/AppProfile/User';
import UserRoles from './components/AppsMenu/AppProfile/UserRoles';
import AddRole from './components/AppsMenu/AppProfile/AddRole';
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import AppProfile2 from "./components/AppsMenu/AppProfile/AppProfile2";
import EditProfile from "./components/AppsMenu/AppProfile/EditProfile";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";
import CustomerProfile from "./components/AppsMenu/AppProfile/CustomerProfile";
import AppCustomer from "./components/AppsMenu/AppProfile/AppCustomer";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";

/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import SparklineChart from "./components/charts/Sparkline";
import ChartJs from "./components/charts/Chartjs";
import RechartJs from "./components/charts/rechart";
import ApexChart from "./components/charts/apexcharts";


/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";
/// Pages
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import Login from "./pages/Login";
import PricingManagement from "./components/PricingManagement/PricingManagement";
import AddPrice from "./components/PricingManagement/AddPrice";
import EditPrice from "./components/PricingManagement/EditPrice";
import Vehicle from "./components/Vehicle/Vehicle";
import EditVehicle from "./components/Vehicle/EditVehicle";
import AddVehicle from "./components/Vehicle/AddVehicle";
import BookingManually from "./components/BookingManually/BookingManually";
import AddBooking from "./components/BookingManually/AddBooking";
import EditBooking from "./components/BookingManually/EditBooking";
import VoucherListing from "./components/Voucher/VoucherListing";
import TravelPlannerList from "./components/TravelPlanner/TravelPlannerList";
import EditSaleCamper from "./components/SaleCamper/EditSaleCamper";
import Database from "./components/CustomerDatabase/database";
import SubscriptionCamper from "./components/SubscriptionCamper/SubscriptionCamper";
import AddSubscriptionCamper from "./components/SubscriptionCamper/AddSubscriptionCamper";
import EditSubscriptionCamper from "./components/SubscriptionCamper/EditSubscriptionCamper";
import Documents from "./components/CustomerDocument/document";
import Pdfprotocol from "./components/Pdfprotocol/Pdfprotocol";
import PdfprotocolAdd from "./components/Pdfprotocol/PdfprotocolAdd";
import PdfprotocolEdit from "./components/Pdfprotocol/PdfprotocolEdit";


import KilometerOffcanvas from "./components/Kilometer/KilometerOffcanvas";
import PackagesItems from "./components/Packages/PackagesItem";
import AddPackagesItems from "./components/Packages/AddPackagesItem";
import EditPackagesItems from "./components/Packages/EditPackagesItem";
import ContactOffcanvas from "./components/Contact/ContactOffcanvas";
import RestrictedPickupOrReturnList from "./components/RestrictedPickuporReturn/RestrictedPickupOrReturnList";
import AddRestricted from "./components/RestrictedPickuporReturn/AddRestricted";
import EditRestricted from "./components/RestrictedPickuporReturn/EditRestricted";
import UnavailableDateList from "./components/UnavailableDates/UnavailableDateList";
import AddUnavailable from "./components/UnavailableDates/AddUnavailableDates";
import EditUnavailable from "./components/UnavailableDates/EditUnavailableDates";

//minimum rent duration
import MinimumRentDurationList from "./components/MinimumRentDurations/MinimumRentDurations";
import AddMinimumRent from "./components/MinimumRentDurations/AddMinimumRent";
import EditMinimumRent from "./components/MinimumRentDurations/EditMinimumRent";

//Banner
import BannerList from "./components/Banner/BannerList";
import AddDocument from "./components/CustomerDocument/AddDocument";
import EditDocument from "./components/CustomerDocument/EditDocument";
import TodayPickupReturn from "./components/Dashboard/TodayPickupReturn";
const allroutes = [
  // Dashboard
  { url: "/", component: <Login /> },
  { url: "dashboard", component: <Home /> },
  { url: "admin/kilometer", component: <KilometerList /> },
  { url: "current-pickups-returns", component: <TodayPickupReturn /> },
  { url: "admin/add_kilometer", component: <KilometerOffcanvas /> },

  { url: "admin/kilometerupdate/:id", component: <KilometerUpdate /> },
  { url: "admin/newsletters", component: <Newsletters /> },
  { url: "admin/newslettersupdate/:id", component: <NewslettersUpdate /> },
  { url: "admin/trip_review", component: <TripReviewList /> },
  { url: "admin/travelplanner", component: <TravelPlannerList /> },
  { url: "admin/manage_travel", component: <UploadTutorialList /> },
  { url: "admin/edit-travel/:id", component: <EditTravel /> },

  { url: "admin/contact", component: <ContactList /> },
  { url: "admin/add-contact", component: <ContactOffcanvas /> },
  { url: "admin/salecontact", component: <SaleContactList /> },
  { url: "admin/users", component: <BookingList /> },
  { url: "admin/booking_calender", component: <BookingCalenderList /> },
  { url: "admin/payment_details", component: <PaymentDetailList /> },


  { url: "performance", component: <Performance /> },
  { url: "project", component: <Projects /> },
  { url: "task-summary", component: <TaskSummary /> },
  { url: "blog", component: <Blog /> },
  { url: "manage-client", component: <ManageClient /> },
  { url: "reports", component: <Report /> },
  { url: "finance", component: <Finance /> },
  { url: "employee", component: <Employees /> },
  { url: "task", component: <Task /> },

  //RestrictedPickupOrReturnList
  { url: "admin/restricted-list", component: <RestrictedPickupOrReturnList /> },
  { url: "admin/add-restricted", component: <AddRestricted /> },
  { url: "admin/edit-restricted/:id", component: <EditRestricted /> },

  //Unavailable
  { url: "admin/unavailable-list", component: <UnavailableDateList /> },
  { url: "admin/add-unavailable", component: <AddUnavailable /> },
  { url: "admin/edit-unavailable/:id", component: <EditUnavailable /> },

  //MinimumRentDurationList
  { url: "admin/minimumrentduration-list", component: <MinimumRentDurationList /> },
  { url: "admin/add-minimumrentduration", component: <AddMinimumRent /> },
  { url: "admin/edit-minimumrentduration/:id", component: <EditMinimumRent /> },
  //Banner

  { url: "admin/banner", component: <BannerList /> },
  /// Services
  { url: "admin/accounting_system", component: <AccountingList /> },
  { url: "admin/edit_accounting/:id", component: <EditAccounting /> },

  /// Services

  // { url: "admin/edit_accounting/:id", component: <EditAccounting /> },
  /// Services
  { url: "admin/services", component: <Services /> },
  { url: "admin/add_services", component: <AddServices /> },
  { url: "admin/edit_services/:id", component: <EditServices /> },

  /// Packages
  { url: "admin/packages", component: <Packages /> },
  { url: "admin/add_packages", component: <AddPackages /> },
  { url: "admin/edit_packages/:id", component: <EditPackages /> },
  /// PackagesItems
  { url: "admin/packagesItem", component: <PackagesItems /> },
  { url: "admin/add_packagesitem", component: <AddPackagesItems /> },
  { url: "admin/edit_packagesitem/:id", component: <EditPackagesItems /> },




  /// Brand
  { url: "admin/brand", component: <Brand /> },
  { url: "admin/add_brand", component: <AddBrand /> },
  { url: "admin/edit_brand/:id", component: <EditBrand /> },

  /// Kitchen
  { url: "admin/kitchen", component: <Kitchen /> },
  { url: "admin/add_kitchen", component: <AddKitchen /> },
  { url: "admin/edit_kitchen/:id", component: <EditKitchen /> },

  /// Kitchen
  { url: "admin/driving", component: <Driving /> },
  { url: "admin/add_driving", component: <AddDriving /> },
  { url: "admin/edit_driving/:id", component: <EditDriving /> },

  //Bathroom management
  { url: "admin/bathroom_management", component: <BathroomManagement /> },
  { url: "admin/add_bathroom_management", component: <AddBathroomManagement /> },
  { url: "admin/edit_bathroom_management/:id", component: <EditBathroomManagement /> },

  //Vehicle Management
  { url: "admin/vehicle", component: <Vehicle /> },
  { url: "admin/add_vehicle", component: <AddVehicle /> },
  { url: "admin/edit_vehicle/:id", component: <EditVehicle /> },
  //Pricing management
  { url: "admin/pricing_management", component: <PricingManagement /> },
  { url: "admin/add_pricing_management", component: <AddPrice /> },
  { url: "admin/edit_pricing_management/:id", component: <EditPrice /> },
  //Living and sleeping
  { url: "admin/living", component: <Living /> },
  { url: "admin/add_living", component: <AddLiving /> },
  { url: "admin/edit_living/:id", component: <EditLiving /> },
  /// Outdoor
  { url: "admin/outdoor", component: <Outdoor /> },
  { url: "admin/add_outdoor", component: <AddOutdoor /> },
  { url: "admin/edit_outdoor/:id", component: <EditOutdoor /> },

  /// Feature
  { url: "admin/feature", component: <Feature /> },
  { url: "admin/add_feature", component: <AddFeature /> },
  { url: "admin/edit_feature/:id", component: <EditFeature /> },

  //Deals

  { url: "admin/deal", component: <Deal /> },
  { url: "admin/add_deal", component: <AddDeal /> },
  { url: "admin/edit_deal/:id", component: <EditDeal /> },

  /// Accessories
  { url: "admin/accessories", component: <Accessories /> },
  { url: "admin/add_accessories", component: <AddAccessories /> },
  { url: "admin/edit_accessories/:id", component: <EditAccessories /> },

  /// Fuel
  { url: "admin/fuel", component: <Fuel /> },
  { url: "admin/add_fuel", component: <AddFuel /> },
  { url: "admin/edit_fuel/:id", component: <EditFuel /> },

  { url: "admin/ad_ons_equipments", component: <AdOns /> },
  { url: "admin/add_equipments", component: <AddAdOns /> },
  { url: "admin/edit_equipments/:id", component: <EditAdOns /> },

  /// Camper
  { url: "admin/campers/:type", component: <Camper /> },
  { url: "admin/add_campers/:type", component: <AddCamper /> },
  { url: "admin/editcamper/:type/:id", component: <EditCamper /> },
  //Sale Camper

  { url: "admin/camper_sale", component: <SaleCamper /> },
  { url: "admin/add_camper_sale", component: <AddSaleCamper /> },
  { url: "admin/edit_campers/:id", component: <EditSaleCamper /> },

  //SubscriptionCamper
  { url: "admin/camper_subscription", component: <SubscriptionCamper /> },
  { url: "admin/add_camper_subscription", component: <AddSubscriptionCamper /> },
  { url: "admin/edit_subscription/:id", component: <EditSubscriptionCamper /> },

  /// Camper
  { url: "admin/explanatory-videos", component: <CamperVideo /> },
  { url: "admin/add_videos", component: <AddCamperVideo /> },
  { url: "admin/edit_videos/:id", component: <EditCamperVideo /> },

  /// Camper
  { url: "admin/discount", component: <Discount /> },
  { url: "admin/add_discount", component: <AddDiscount /> },
  { url: "admin/edit_discount/:id", component: <EditDiscount /> },

  //Booking Manually
  { url: "admin/booking", component: <BookingManually /> },
  { url: "admin/addbooking", component: <AddBooking /> },
  { url: "admin/edit_booking/:id", component: <EditBooking /> },
  /// Camper
  { url: "admin/blogs", component: <AdminBlog /> },
  { url: "admin/add_blog", component: <AddBlog /> },
  { url: "admin/edit_blog/:id", component: <EditBlog /> },

  /// Voucher
  { url: "admin/vouchers", component: <AdminVoucher /> },
  { url: "admin/voucherlist", component: <VoucherListing /> },
  { url: "admin/add-voucher", component: <AddVoucher /> },
  { url: "admin/edit-voucher/:id", component: <EditVoucher /> },
  //Customer Database
  { url: "admin/database", component: <Database /> },
  //Customet Documents
  { url: "admin/documents/:id", component: <Documents /> },
  { url: "admin/add-documents/:id", component: <AddDocument /> },
  { url: "admin/edit-documents/:id", component: <EditDocument /> },
  
  // PDF protocol
  { url: "admin/pdfprotocol/:id", component: <Pdfprotocol /> },
  { url: "admin/pdfadd/:id", component: <PdfprotocolAdd /> },
  { url: "admin/pdfedit/:id", component: <PdfprotocolEdit /> },
  
  /// Cancellation Policy
  { url: "admin/cancellation-policy", component: <AdminCancellationPolicy /> },
  { url: "admin/add-cancellation-policy", component: <AddCancellationPolicy /> },
  { url: "admin/edit-cancellation-policy/:id", component: <EditCancellationPolicy /> },
  /// Packages
  { url: "admin/cancellation-policy-items", component: <Location /> },
  { url: "admin/add_cancellation-policy-items", component: <AddLocation /> },
  { url: "admin/edit_cancellation-policy-items/:id", component: <EditLocation /> },

  /// Camper



  //Apps
  { url: "contacts", component: <Contacts /> },
  { url: "user", component: <User /> },
  { url: "user-roles", component: <UserRoles /> },
  { url: "add-role", component: <AddRole /> },
  { url: "app-profile", component: <AppProfile /> },
  { url: "app-profile-2", component: <AppProfile2 /> },
  { url: "edit-profile", component: <EditProfile /> },
  { url: "post-details", component: <PostDetails /> },
  { url: "customer", component: <AppCustomer /> },
  { url: "customer-profile", component: <CustomerProfile /> },
  // Apps  
  { url: "email-compose", component: <Compose /> },
  { url: "email-inbox", component: <Inbox /> },
  { url: "email-read", component: <Read /> },
  { url: "app-calender", component: <Calendar /> },

  // Shop
  { url: "ecom-product-grid", component: <ProductGrid /> },
  { url: "ecom-product-list", component: <ProductList /> },
  { url: "ecom-product-detail", component: <ProductDetail /> },
  { url: "ecom-product-order", component: <ProductOrder /> },
  { url: "ecom-checkout", component: <Checkout /> },
  { url: "ecom-invoice", component: <Invoice /> },
  { url: "ecom-customers", component: <Customers /> },
  // Chart
  { url: "chart-sparkline", component: <SparklineChart /> },
  { url: "chart-chartjs", component: <ChartJs /> },
  { url: "chart-apexchart", component: <ApexChart /> },
  { url: "chart-rechart", component: <RechartJs /> },

  // Form
  { url: "form-element", component: <Element /> },
  { url: "form-wizard", component: <Wizard /> },
  { url: "form-ckeditor", component: <CkEditor /> },
  { url: "form-pickers", component: <Pickers /> },
  { url: "form-validation", component: <FormValidation /> },


];

const ROLE_ADMIN = "admin";
const ROLE_STAFF = "staff";
const STAFF_ALLOWED_PATHS = new Set([
  "current-pickups-returns",
  "admin/contact"
]);

const getCurrentUserRoles = () => {
  try {
    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    const roles = userData?.roles?.map((role) =>
      String(role?.name || "")
        .trim()
        .toLowerCase()
    ) || [];
    return new Set(roles);
  } catch {
    return new Set();
  }
};

const canAccessRoute = (routeUrl) => {
  const roles = getCurrentUserRoles();
  const isAdmin = roles.has(ROLE_ADMIN);
  const isStaff = roles.has(ROLE_STAFF);

  // No role: block protected area
  if (!isAdmin && !isStaff) return false;

  // Admin can access all routes.
  if (isAdmin) return true;

  // Staff can access only selected routes.
  return STAFF_ALLOWED_PATHS.has(routeUrl);
};

const RoleProtectedRoute = ({ routeUrl, children }) => {
  if (canAccessRoute(routeUrl)) return children;

  const roles = getCurrentUserRoles();
  if (roles.has(ROLE_STAFF)) {
    return <Navigate to="/current-pickups-returns" replace />;
  }
  return <Navigate to="/page-error-403" replace />;
};

const Markup = () => {

  function NotFound() {
    const url = allroutes.map((route) => route.url);

    let path = window.location.pathname
    path = path.split('/')
    path = path[path.length - 1]

    if (url.indexOf(path) <= 0) {
      return <Error404 />
    }
  }

  // var loginDetails =localStorage.getItem('admintoken')
  // const navigate = useNavigate();
  // React.useEffect(()=>{
  // if(loginDetails === null)
  //   {


  //       navigate("/")


  //   }
  //   else{
  //     setTimeout(() => {
  //       localStorage.removeItem('admintoken')
  //       localStorage.removeItem('user')
  //     }, 604800);
  //   }
  // })
  return (
    <>
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/page-lock-screen' element={<LockScreen />} />
        <Route path='/page-error-400' element={<Error400 />} />
        <Route path='/page-error-403' element={<Error403 />} />
        <Route path='/page-error-404' element={<Error404 />} />
        <Route path='/page-error-500' element={<Error500 />} />
        <Route path='/page-error-503' element={<Error503 />} />
        <Route element={<MainLayout />} >
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={
                data.url === "/"
                  ? data.component
                  : <RoleProtectedRoute routeUrl={data.url}>{data.component}</RoleProtectedRoute>
              }
            />
          ))}
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
      <ScrollToTop />
    </>
  );
};


function MainLayout() {
  const sideMenu = useSelector(state => state.sideMenu);
  return (
    <div id="main-wrapper" className={`show ${sideMenu ? "menu-toggle" : ""}`}>
      <Nav />
      <div className="content-body" style={{ minHeight: window.screen.height - 45 }}>
        <Outlet />
      </div>
      <Footer />
    </div>
  )
};



export default Markup;
